// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_iz-0";